import { AsyncPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable,
} from '@angular/material/table';
import { NgxPaginationModule } from 'ngx-pagination';
import { OnlysuperuserDirective } from '../../../../shared/directives/onlysuperuser.directive';
import { PermisionDirective } from '../../../../shared/directives/permision.directive';
import { Search } from '../../../../shared/components/search/search';
import { LayoutService } from '../../../../core/services/layout/layout';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { AddressService } from '../../../../core/services/address/address-service';
import { LoadingService } from '../../../../core/services/loading/loading';
import { Title } from '@angular/platform-browser';
import { catchError, map, Observable, switchMap, tap } from 'rxjs';
import { Address } from '../../../../core/models/address.interface';
import { Filter, QueryGet } from '../../../../core/types/query-types';
import { PAGINATION } from '../../../../core/constants/constants';
import { AddressForm } from '../address-form/address-form';

@Component({
  selector: 'app-address-list',
  imports: [
    MatIcon,
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    NgxPaginationModule,
    AsyncPipe,
    OnlysuperuserDirective,
    PermisionDirective,
    Search,
  ],
  templateUrl: './address-list.html',
  styleUrl: './address-list.scss',
})
export class AddressList {
  public page = 1;
  total: number = 0;
  limit: number = 10;
  addresses: Address[] = [];
  asyncAddress!: Observable<Address[]>;
  buscaraddress: string = '';
  @Input() filtro: string = '';
  @Input() orden: string = '';
  showColumns: string[] = [
    'acciones',
    'id',
    'street',
    'number',
    'complement',
    'territory',
    'authority',
  ];

  constructor(
    private layoutService: LayoutService,
    private activatedRouter: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private toastr: ToastrService,
    private addressService: AddressService,
    private loadingService: LoadingService,
    private title: Title,
  ) {
    this.title.setTitle('Direcciones');
  }

  ngOnInit(): void {
    this.layoutService.paginationLimit$
      .pipe(
        switchMap((limit) => {
          this.limit = limit;
          return this.activatedRouter.queryParamMap;
        }),
        switchMap((params) => {
          const pageNum = params.get('page') || '1';
          const search = params.get('search') || '';
          this.page = parseInt(pageNum);
          this.fetchAddress(PAGINATION.first_page, null, search);
          return this.layoutService.paginationLimit$;
        }),
      )
      .subscribe();
  }

  fetchAddress(page: number, filter: Filter | null = null, search = '') {
    const offset = page > 1 ? page * this.limit - this.limit : 0;
    const params: QueryGet = {
      order: '-id',
      limit: this.limit,
      offset,
      search,
      filters: [],
    };
    if (filter) {
      params.filters.push(filter);
    }
    this.page = page;
    this.loadingService.show(true);
    this.asyncAddress = this.addressService.getAddress(params).pipe(
      tap((data) => {
        this.addresses = data.results;
        this.addressService.setAddress(data.results[0]);
        this.addressService.setAddresses(data.results);
        this.total = data.count;
      }),
      map((res) => {
        this.loadingService.show(false);
        return res.results;
      }),
      catchError((error) => {
        this.loadingService.show(false);
        const errorMsg = `¡Se ha producido un error, inténtelo nuevamente!`;
        this.toastr.error(errorMsg, 'Error!', {
          progressBar: true,
          timeOut: 5000,
        });
        this.router.navigate(['home']);
        return [];
      }),
    );
  }

  createAddress() {
    this.addressService.removeAddressSelected();
    const dialogRef = this.dialog.open(AddressForm, {
      width: '600px',
      height: 'auto',
      maxHeight: '80vh',
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(() => {
      this.fetchAddress(this.page);
    });
  }

  updateAddress(address: Address) {
    this.addressService.setAddress(address);
    const dialogRef = this.dialog.open(AddressForm, {
      width: '600px',
      height: 'auto',
      maxHeight: '80vh',
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(() => {
      this.fetchAddress(this.page);
    });
  }

  eliminate(address: Address): void {
    const confirmed = window.confirm(`¿Estás seguro de eliminar el registro: ${address.street}?`);
    if (!confirmed) return;
    this.addressService.delete(address.id).subscribe({
      next: () => {
        const successMsg = `Eliminado CORRECTAMENTE!`;
        this.toastr.success(successMsg, 'Exitoso!', {
          progressBar: true,
          timeOut: 5000,
        });
        this.fetchAddress(this.page);
      },
      error: (err) => {
        this.toastr.error('No se pudo eliminar', 'Error');
      },
    });
  }
}
